export const QUALTRICS_DOMAIN = 'https://jsainsbury.fra1.qualtrics.com'
